<template>
  <div class="home">
    <!-- pc -->
    <template v-if="!isShow">
      <el-container class="pc">
        <!-- 头部 -->
        <el-header class="clearfloat">
          <div class="v_header">
            <div class="h_right fr">
              <span class="f14" v-if="userName">{{userName}},你好</span>
              <router-link to="/login" v-else>未登录，请先登录</router-link>
              <span class="f14" v-if="userName">
                <router-link to="/personalinfo">个人中心</router-link>
                <router-link to="/homenotice">公告</router-link>
              </span>
            </div>
          </div>
        </el-header>
        <!-- 主体部分 -->
        <div class="v_main">
          <!-- 轮播图 -->
          <div class="v_image">
            <div style="height:412px;">
              <el-image :src="homeImgUrl" fit="cover"></el-image>
              <!-- <el-image v-if="imgList[0]" :src="imgList[0].url" fit="cover"></el-image> -->
            </div>
          </div>
          <!-- 搜索框 -->
          <el-card class="v_search">
            <el-row>
              <el-col :span="6">
                <div class="fl">
                  <!-- <span> <i style="font-size:18px;" class="el-icon-files"></i></span> -->
                  <el-select
                    @keyup.enter.native="integSearch"
                    class="div-input-border"
                    filterable
                    allow-create
                    default-first-option
                    v-model="typeName"
                    @change="selectTypeName"
                  >
                    <el-option
                      v-for="item in typeList"
                      :key="item.id"
                      :label="item.title"
                      :value="item.title"
                    ></el-option>
                  </el-select>
                </div>
                <div class="fl">
                  <i class="line"></i>
                </div>
               <!--  <div class="fl">
                  <el-input
                    class="div-input-width"
                    style="font-size:16px"
                    prefix-icon="el-icon-search"
                    placeholder="名称/关键词/简介"
                    v-model="searchValue"
                  ></el-input>
                </div> -->
              </el-col>
              <el-col :span="10">
                <div class="fl div-input-width">
                  <!-- <i class="el-icon-search"></i> -->
                  <el-input
                   @keyup.enter.native="integSearch"
                    class="div-input-border"
                    style="font-size:16px"
                    prefix-icon="el-icon-search"
                    placeholder="名称/关键词/简介"
                    v-model="searchValue"
                  ></el-input>
                </div>
              </el-col>
              <el-col class="tar" :span="8">
                <el-button
                  @click="integSearch"
                  style="padding:15px 30px;font-size:16px;"
                  type="primary"
                  icon="el-icon-search"
                >综合检索</el-button>
                <router-link to="/videolist2?from=0&isClear=0">
                  <el-button style="padding:15px 30px;font-size:16px;background:#E6A23C;color:#fff;">高级检索</el-button>
                </router-link>
              </el-col>
            </el-row>
          </el-card>
          <!-- ----------最新改版-------- -->
          <div v-if="noticeTitle && isTan == true" class="main" style="top:20px;position:relative;">
            <!-- <router-link to="/homenotice">更多</router-link> -->
            <router-link to="/homenotice">
              <el-alert :closable="false" :title="'最新公告：'+noticeTitle" type="warning"></el-alert>
            </router-link>
            <i @click="isTan = false"  onClick="event.cancelBubble = true" class="el-icon-close" style="display:block;position:absolute;top:50%;right:0px;color:#E6A23C;transform: translate(-50%,-50%);font-size:20px;"></i>
          </div>
          <div class>
            <PCHome />
          </div>
        </div>
        <!-- 底部 -->
        <div class="v_footer">
          <Foot />
        </div>
      </el-container>
    </template>
    <!-- 【mobile】 -->
    <template v-if="isShow">
      <div class="mobile">
        <MobHome />
        <!-- 顶部 -->
      </div>
    </template>
  </div>
</template>

<script>
import VideoList from '../components/home/videolist/videolist'
import Foot from '../components/footer/footer.vue'
import common from '../utils/common.utils'
import MFooter from '../components/footer/mfooter.vue'
import PCHome from '../components/common/main.vue'
// mobile
// import MobHome from "../components/mobile/home";
import MobHome from '../components/common/mobhome'

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
export default {
  name: 'home',
  components: {
    Foot,
    MFooter,
    VideoList,
    PCHome,
    MobHome
  },
  data: function () {
    return {
      isTan: true,
      homeImgUrl: require('../assets/img/pchome.jpg'),
      noticeTitle: '', // 弹出的公告内容
      searchValue: '', // 名称关键词简介
      userName: '',
      productCount: '', // 成片数量
      materialCount: '', // 素材数量
      logoUrl: require('../assets/img/logo2.png'),
      isShow: false,
      imgList: [],

      recommondList: [
        {
          id: 0,
          imgUrl: require('../assets/img/05.jpg')
        },
        {
          id: 1,
          imgUrl: require('../assets/img/06.png')
        },
        {
          id: 2,
          imgUrl: require('../assets/img/06.png')
        }
      ], // 精彩推荐咨询快报
      videoList: [
        {
          id: 0,
          imgPath: require('../assets/img/06.png')
        },
        {
          id: 1,
          imgPath: require('../assets/img/05.jpg')
        },
        {
          id: 2,
          imgPath: require('../assets/img/02.jpg')
        },
        {
          id: 3,
          imgPath: require('../assets/img/02.jpg')
        }
      ], // 视频推荐-名家访谈
      showList: [], // 展节直击
      newvideoList: [], // 最新视频
      typeList: [], // 二级分类
      screenWidth: document.body.offsetWidth, // 屏幕宽度

      page: 0,
      isBtnShow: false,
      // 【搜索条】
      typeName: ''
    }
  },
  methods: {
    goNotice: function () {
      alert(11)
    },
    // 弹出的公告内容
    getOpenNotice: async function () {
      var res = await this.$http.get(`/v1/notice/getOpenNoitce`)
      var { code, message, data } = res.data
      if (code == 0) {
        this.noticeTitle = data.title
      }
    },
    // // 首页轮播图
    getCodeList: async function () {
      var res = await this.$http.get('/v1/advertise/getByCode?code=Ting01')
      var { code, data, message } = res.data
      if (code == 0) {
        this.imgList = data
      }
    },
    // 获取文艺类视频的二级分类
    getTypeList: async function () {
      var res = await this.$http.get('/v1/index/videoTypeList')
      var { code, data } = res.data
      if (code == 0) {
        this.typeList = data

        // console.log(this.typeList)
      }
    },
    // 【顶部搜索条】
    selectTypeName: function () {
      console.log(this.typeName)
    },
    // 综合检索
    integSearch: function () {
      if (this.typeName !== '' || this.searchValue !== '') {
        this.$router.push({
          path: '/videolist2',
          query: {
            from: true,
            typeName: this.typeName,
            retrieval: this.searchValue
          }
        })
      } else {
        this.$message.info('请选择搜索条件')
      }
    }
  },
  created () {
    this.getCodeList()
    this.isShow = common._isMobile()
  },
  mounted: function () {
    this.getOpenNotice()
    this.isShow = common._isMobile()
    if (window.localStorage.getItem('token')) {
      console.log('已登录')
      this.userName = window.localStorage.getItem('userName')
      console.log(window.localStorage.getItem('userName'))
      console.log(this.$store.state.userInfo)
    } else {
      console.log('未登录')
      this.$store.state.userInfo = {}
      this.userName = ''
    }
    // console.log(this.$store.state.userInfo)
    this.getTypeList()
  },
  computed: {
  },
  watch: {
  }
}
</script>
<style lang="scss" scoped>
@import "@/assets/css/pchome.scss";
.home {
  height: 100%;
  background-color: #fff !important;
}
.el-image {
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    // display: block;
    vertical-align: middle;
  }
}
a {
  color: #3399ff;
}
.pc {
  .el-container {
    position: relative;
    margin: 0 auto;
  }

  // 轮播图
  .v_main .el-carousel .el-carousel__arrow {
    font-size: 30px !important;
  }
  .v_image {
    min-width: 1200px;
    position: static;
    z-index: 1;
  }
  .v_main .v_image {
    position: relative;
    text-align: center;
    .v_text {
      position: absolute;
      font-size: 50px;
      font-weight: bold;
      color: #fff;
      left: 0;
      right: 0px;
      top: 50%;
      margin-top: -20px;
      // margin: auto;
      z-index: 9999;
    }
  }

  .el-header {
    padding: 0;
    position: absolute;
    top: 0;
    width: 100%;
    // background-color: #000;
    // opacity: .2;
    background: rgba(0, 0, 0, 0.2);
    height: 70px;
    line-height: 70px;
    // padding: 0 10px;
    z-index: 999;
    text-align: center;
  }

  // 头部
  .v_header {
    max-width: 1200px;
    margin: 0 auto;
    a {
      color: #fff;
    }
    .h_left {
      line-height: 70px;
      justify-content: center;
      .h-l-image {
        width: 40px;
        height: 40px;
        margin-top: 13px;
        .el-image {
          img {
            vertical-align: center;
          }
        }
      }
    }
  }
  .v_header span {
    color: #fff;
    margin: 0 5px;
    font-weight: bold;
  }

  // 搜索框
  .v_search {
    position: relative;
    z-index: 3;
    // height: 86px;
    width: 1200px;
    background-color: #fff;
    margin: 0 auto;
    margin-top: -30px;
    padding: 10px;

    // line-height: 90px;
    .el-row {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .left_btn {
      cursor: pointer;
      color: #fff;
      border-radius: 13px;
      padding: 10px;
      text-align: center;
      .tt {
        font-size: 18px;
        font-weight: bold;
      }
    }
    .line {
      display: inline-block;
      width: 1px;
      height: 39px;
      background-color: #ccc;
      margin: 0 20px;
    }
  }
}

//底部
.v_footer {
  margin-top: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue